import styled, { css } from 'styled-components';
import { suppressProps } from '../../utils/suppress-props.js';
import { Text } from '../text/index.js';
const getSettingStyles = ({ theme, setting }) => {
    const { color, textDecorationLine, textDecorationThickness, ...otherSettingStyles } = theme.styles.links.settings[setting];
    return {
        color: theme.colors.text[color],
        textDecorationLine: theme.textDecorationLines[textDecorationLine],
        textDecorationThickness: theme.textDecorationThicknesses[textDecorationThickness],
        ...otherSettingStyles,
    };
};
const getVariantStyles = ({ theme, variant }) => {
    const { fontSizes, fontWeights, lineHeights, letterSpacings, styles } = theme;
    const { fontWeight, fontSize, lineHeight, letterSpacing } = styles.links.variants[variant];
    return css `
    font-weight: ${fontWeights[fontWeight]};
    font-size: ${fontSizes[fontSize]};
    line-height: ${lineHeights[lineHeight]};
    letter-spacing: ${letterSpacings[letterSpacing]};
  `;
};
const getSettingStates = ({ theme, setting }) => {
    const settingOptions = theme.styles.links.settings[setting];
    return Object.fromEntries([':hover', ':active', ':visited'].map((state) => [
        state,
        settingOptions[state],
    ]));
};
const getFocusStyles = ({ theme, isFocusVisible }) => isFocusVisible
    ? css `
        &:focus {
          outline: ${theme.outlines.link.rule};
          outline-offset: ${theme.outlines.link.offset};
          border-radius: ${theme.outlines.link.borderRadius};
        }
      `
    : css `
        outline: ${theme.outlines.none};
      `;
const getDisabledStyles = ({ isDisabled }) => {
    if (!isDisabled)
        return css ``;
    return css `
    pointer-events: none;
  `;
};
export const LinkElement = styled(Text)
    .withConfig(suppressProps('isDisabled', 'setting', 'variant', 'onPress', 'isFocusVisible', 'shouldPreventNavigation'))
    .attrs(({ theme, loading, setting }) => ({
    color: loading ? theme.styles.links.settings[setting].color : undefined,
}))(() => css `
    overflow: inherit;
    text-overflow: inherit;
  `, ({ theme }) => theme.styles.links.base, getVariantStyles, getFocusStyles, getDisabledStyles, getSettingStyles, getSettingStates);
//# sourceMappingURL=link.styles.js.map